import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { queryClient } from "./_helper/actions/query";
import { QueryClientProvider } from "react-query";
import { Provider } from "jotai";
import UserRouting from "./UserRouting";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "reactjs-popup/dist/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import {
  BLACK,
  DARK_GREY,
  LIGHT_GREEN,
  LIGHT_GREY,
  THEME_CLR,
} from "./_helper/constant/constant";
import { Worker } from "@react-pdf-viewer/core";

function App() {
  useEffect(() => {
    document.documentElement.style.setProperty("--main-color", THEME_CLR);
    document.documentElement.style.setProperty("--darkgrey-color", DARK_GREY);
    document.documentElement.style.setProperty("--lighgrey-color", LIGHT_GREY);
    document.documentElement.style.setProperty("--black-color", BLACK);
    document.documentElement.style.setProperty(
      "--lightgreen-color",
      LIGHT_GREEN
    );
  }, []);

  return (
    <Provider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ToastContainer />
          <ErrorBoundary>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
              <UserRouting />
            </Worker>
          </ErrorBoundary>
        </QueryClientProvider>
      </BrowserRouter>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
